export const SalesMetricBasis = {
    BILLED: 'BILLED',
    BILLED_WO_CREDIT_NOTE: 'BILLED_WO_CREDIT_NOTE',
    NOT_BILLED: 'NOT_BILLED',
    ORDER_SUM: 'ORDER_SUM',
} as const;

export type SalesMetricBasis = (typeof SalesMetricBasis)[keyof typeof SalesMetricBasis];
